<template>
  <ul
    class="benefits-list"
    :class="{
      '--not-by-3-even-4':
        list.length === 4 && list.length % 3 !== 0 && list.length % 2 === 0,
      '--not-by-3-even':
        list.length > 4 && list.length % 3 !== 0 && list.length % 2 === 0,
      '--not-by-3-odd':
        list.length > 3 && list.length % 3 !== 0 && list.length % 2 !== 0,
    }"
  >
    <li v-for="item in list" :key="item.id" class="benefits-list__item">
      <div
        v-if="item.title"
        class="benefits-list__item__title text-xl-2"
        v-html="item.title"
      />
      <div
        v-if="item.text"
        class="benefits-list__item__text text-xl-3"
        v-html="item.text"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesTechnologyBenefits',
}
</script>

<script setup>
const props = defineProps({
  list: Array,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
